import StudentInformanceMain from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentInformance/StudentInformanceMain";
import "./index.css";
import RightArrow from "Assets/Icons/RightArrow";
import AddNewComponentFooter from "Pages/StudentPortfolio/StudentPortfolioMobile/AddNewComponentFooter";
import StudentPortfolioSlider from "Pages/StudentPortfolio/StudentPortfolioMobile/StudentPortfolioSlider";
import { useState } from "react";
import StudentCommentSection from "Pages/StudentPortfolio/StudentCommentSection/StudentCommentSection";
const StudentPortfolioMainMobile = ({
  tabs,
  selectedStudent,
  commentsObj,
  setCommentsObj,
}: any) => {
  const [isPaneOpen, setisPaneOpen] = useState<boolean>(false);
  const [isPaneOpenComment, setIsPaneOpenComment] = useState(false);
  const [component, setComponent] = useState<any>("");

  const paneOpenCommentToggle = () => {
    setIsPaneOpenComment(!isPaneOpenComment);
  };
  const addCommentHandler = () => {
    paneOpenCommentToggle();
  };
  const viewCommentHandler = () => {
    paneOpenCommentToggle();
  };
  const toggle = () => {
    setisPaneOpen(!isPaneOpen);
  };
  const selectListHandler = (ele: any) => {
    toggle();
    setComponent(ele);
  };
  const selectStudentDetailHandler = () => {
    const StudentDetailTab = tabs.find(
      (item: any) => item.label == "Student Details"
    );
    toggle();
    setComponent(StudentDetailTab);
  };
  return (
    <div className="mobileViewMainRow">
      <StudentPortfolioSlider
        commentsObj={commentsObj}
        isPaneOpen={isPaneOpen}
        setisPaneOpen={setisPaneOpen}
        onRequestClose={toggle}
        addCommentHandler={addCommentHandler}
        viewCommentHandler={viewCommentHandler}
        tabs={tabs}
        component={component}
        setComponent={setComponent}
      >
        {component.component}
      </StudentPortfolioSlider>
      <div>
        <StudentInformanceMain
          selectStudentDetailHandler={selectStudentDetailHandler}
          selectedStudent={selectedStudent}
        />
      </div>
      <div className="p-0 tabsDiv mb-5">
        {tabs.map((ele: any, index: number) => {
          return (
            <div
              key={index}
              className={"studentPortfolioDiv"}
              onClick={() => {
                selectListHandler(ele);
              }}
            >
              <div className="d-flex">
                <span className="ml-2">{ele?.label}</span>
              </div>
              <div>
                <RightArrow />
              </div>
            </div>
          );
        })}
      </div>
      <StudentCommentSection
        commentsObj={commentsObj}
        setCommentsObj={setCommentsObj}
        isPaneOpen={isPaneOpenComment}
        setIsPaneOpen={setIsPaneOpenComment}
        isPaneOpenComment={isPaneOpenComment}
      ></StudentCommentSection>
      <div>
        <AddNewComponentFooter
          selectedStudent={selectedStudent}
          commentsObj={commentsObj}
          addCommentHandler={addCommentHandler}
          viewCommentHandler={viewCommentHandler}
        />
      </div>
    </div>
  );
};
export default StudentPortfolioMainMobile;
